module.exports = __webpack_public_path__ + "static/character--pluggy-forward@3x.43ce34c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/character--pluggy-forward@3x.png
// module id = 128
// module chunks = 168707334958949